import {
  CLASS_DETAILS,
  GYM_CLASS_DETAILS,
  INDUCTION_CLASS_DETAILS,
  PERSONAL_TRAINING_SESSION_DETAILS,
  SWIMMING_CLASS_DETAILS,
  TENNIS_CLASS_DETAILS,
  MASSAGE_CLASS_DETAILS,
  PRODUCT_TYPES,
  CLASS_TYPES
} from '../constants';
import moment from 'moment';

export const countClassAttendees = (attendanceList) =>
  attendanceList && attendanceList.length > 0
    ? attendanceList.filter((elem) => elem.status === 'active' || elem.status === 'attended').length
    : 0;

export const returnProductTypeName = (productType) => {
  if (productType === PRODUCT_TYPES.PERSONAL_TRAINING_PASS) {
    return `Training sessions`;
  } else if (productType === PRODUCT_TYPES.CLASS_PASS) {
    return `Class passes`;
  } else if (productType === PRODUCT_TYPES.GYM_CLASS) {
    return `Gym bookings passes`;
  } else if (productType === PRODUCT_TYPES.SWIMMING_CLASS) {
    return `Swim bookings passes`;
  } else if (productType === PRODUCT_TYPES.TENNIS_CLASS) {
    return `Tennis bookings passes`;
  } else if (productType === PRODUCT_TYPES.MASSAGE_CLASS) {
    return `Massage bookings passes`;
  }
};

export const returnProductName = (productType) => {
  switch (productType) {
    case CLASS_DETAILS.type:
      return CLASS_DETAILS.name;
    case GYM_CLASS_DETAILS.type:
      return GYM_CLASS_DETAILS.name;
    case INDUCTION_CLASS_DETAILS.type:
      return INDUCTION_CLASS_DETAILS.name;
    case PERSONAL_TRAINING_SESSION_DETAILS.type:
      return PERSONAL_TRAINING_SESSION_DETAILS.name;
    case SWIMMING_CLASS_DETAILS.type:
      return SWIMMING_CLASS_DETAILS.name;
    case TENNIS_CLASS_DETAILS.type:
      return TENNIS_CLASS_DETAILS.name;
    case MASSAGE_CLASS_DETAILS.type:
      return MASSAGE_CLASS_DETAILS.name;
    default:
      return '';
  }
};

export const returnClassesDetails = (classType) => {
  switch (classType) {
    case 'class':
      return CLASS_DETAILS;
    case 'personalTraining':
      return PERSONAL_TRAINING_SESSION_DETAILS;
    case 'induction':
      return INDUCTION_CLASS_DETAILS;
    case 'gymClass':
      return GYM_CLASS_DETAILS;
    case 'swimmingClass':
      return SWIMMING_CLASS_DETAILS;
    case 'tennisClass':
      return TENNIS_CLASS_DETAILS;
    case 'massageClass':
      return MASSAGE_CLASS_DETAILS;
    default:
      return '';
  }
};

export const classDateAndTime = (selectedClass) =>
  moment(selectedClass.classDate).set({
    hour: moment(selectedClass.classTime, ['h:mm A']).get('hour'),
    minute: moment(selectedClass.classTime, ['h:mm A']).get('minute')
  });

export const returnCancelClassDetails = (selectedClass, userRole) => {
  const messages = {
    clientCancel:
      'Are you sure you wish to cancel? Refund/credit will be issued if applicable. Please see FAQs and terms and conditions for cancellation policy.',
    clientLateCancellation:
      'Are you sure you wish to cancel? As this is a late cancellation no refund/credit will be issued.',
    clientFreeClassCancellation: 'Are you sure you wish to cancel?',
    adminCancelClass: 'Are you sure you wish to cancel? Any booked customers will be notified',
    adminLateCancellation:
      'Are you sure you wish to cancel? As this is a late cancellation, no refund/credit will be issued. Any booked customers will be notified',
    adminCheckTiming: "It's late cancellation. Do you want to charge customers?"
  };
  const minimalTimeCancellationInHours = selectedClass.minimalTimeCancellationInHours
    ? selectedClass.minimalTimeCancellationInHours
    : selectedClass.__t === 'class'
    ? 2
    : selectedClass.__t === 'personalTraining'
    ? 24
    : 12;
  const isLateCancellation =
    moment.duration(classDateAndTime(selectedClass).diff(moment())).asHours() < minimalTimeCancellationInHours;

  const isFreeClass = selectedClass.cost === 0;
  const checkTiming =
    ((selectedClass.__t === 'personalTraining' && isLateCancellation) || (userRole !== 'user' && isLateCancellation)) &&
    !isFreeClass;

  if (userRole === 'user') {
    return {
      isLateCancellation,
      isFreeClass,
      message: isFreeClass
        ? messages.clientFreeClassCancellation
        : isLateCancellation
        ? messages.clientLateCancellation
        : messages.clientCancel
    };
  } else {
    return {
      isLateCancellation,
      isFreeClass,
      checkTiming,
      message: isFreeClass
        ? messages.adminCancelClass
        : checkTiming
        ? messages.adminCheckTiming
        : isLateCancellation
        ? messages.adminLateCancellation
        : messages.adminCancelClass
    };
  }
};

export const hasClassStarted = (ssClass, addMinutes = 0) =>
  moment() > moment(classDateAndTime(ssClass)).add(addMinutes, 'minutes');

export const isFullClass = (ssClass) => ssClass.limit - countClassAttendees(ssClass.attendanceList) === 0;

export const returnClassPrice = (ssClass, userData) =>
  userData.customerType === 'full-member'
    ? ssClass.membershipClassPrice
      ? ssClass.membershipClassPrice
      : userData.currentMembershipPlan &&
        userData.currentMembershipPlan.ssPlanId &&
        userData.currentMembershipPlan.ssPlanId.classPrice
      ? userData.currentMembershipPlan.ssPlanId.classPrice
      : ssClass.cost
    : ssClass.cost;

export const returnArrayOfClassesDetailInSelectedGym = (gymSettings) => {
  const result = [];
  CLASS_TYPES.forEach((elem) => {
    if (gymSettings[elem]) {
      result.push(returnClassesDetails(elem));
    }
  });
  return result;
};

export const returnAllUpcomingClasses = (classesList) => {
  let classes = [];
  if (classesList && classesList.length > 0) {
    classesList.forEach((elem) => (classes = Array.concat(classes, elem.classes)));
  }
  return classes;
};
